import moment from "moment";
import { create } from "zustand";

const TODAY = moment();

export const useMainStore = create((set, get) => ({
  yearsToLive: localStorage.getItem("ytl") || 80,
  dateOfBirth: localStorage.getItem("dob") || TODAY,
}));
